'use client';

import { useState } from 'react';

import { CreatorCard } from '@kezios/design-system';
import { Carousel } from '@mantine/carousel';
import { useDisclosure } from '@mantine/hooks';
import { YoutubeModal } from 'components/website/components/modals/YoutubeModal/YoutubeModal';
import { useTranslations } from 'next-intl';

import { CarouselSectionLayout } from './CarouselSectionLayout';

export type CarouselSectionProps = {
  creatorOpinions: {
    content: string;
    name: string;
    job: string;
    rating: number;
    thumbnail: string;
    videoUrl: string;
  }[];
};

export const CarouselSection = ({ creatorOpinions }: CarouselSectionProps) => {
  const t = useTranslations('section.carousel');

  const [modalOpened, { toggle }] = useDisclosure(false);
  const [videoUrl, setVideoUrl] = useState('');
  const [title, setTitle] = useState('');

  const displayVideo = (url: string, title: string) => {
    setVideoUrl(url);
    setTitle(title);
    toggle();
  };

  return (
    <>
      <YoutubeModal
        isOpen={modalOpened}
        onClose={() => toggle()}
        youtubeUrl={videoUrl}
        title={title}
      />
      <CarouselSectionLayout
        title={t('title')}
        subtitle={t('subtitle')}
        category={t('category')}
      >
        <Carousel
          slideSize={{ base: '398px' }}
          w={'100%'}
          className="section"
          mx="auto"
          align="center"
          dragFree
          loop
        >
          {creatorOpinions.map((opinion, index) => (
            <Carousel.Slide key={`${index}-${opinion.name}`}>
              <CreatorCard
                imageSrc={opinion.thumbnail}
                name={opinion.name}
                job={opinion.job}
                content={`“${opinion.content}”`}
                rating={opinion.rating}
                onClick={() => displayVideo(opinion.videoUrl, opinion.name)}
                w={350}
                style={{
                  margin: '0 24px',
                }}
              />
            </Carousel.Slide>
          ))}
        </Carousel>
      </CarouselSectionLayout>
    </>
    // <Carousel id="influencer" className="section" variant="review" mx={'auto'}>
    //   {modalOpened && (
    //     <YoutubeModal
    //       isOpen={modalOpened}
    //       onClose={() => toggle()}
    //       youtubeUrl={videoUrl}
    //       title={title}
    //     />
    //   )}
    //   <ReviewSlide
    //     review={t('first.review')}
    //     author={t('first.author')}
    //     authorJob={t('first.job')}
    //     thumbnail={t('first.thumbnail')}
    //     onClick={() => displayVideo(t('first.link'), t('first.author'))}
    //   />
    //   <ReviewSlide
    //     review={t('second.review')}
    //     author={t('second.author')}
    //     authorJob={t('second.job')}
    //     thumbnail={t('second.thumbnail')}
    //     onClick={() => displayVideo(t('second.link'), t('second.author'))}
    //   />
    //   <ReviewSlide
    //     review={t('third.review')}
    //     author={t('third.author')}
    //     authorJob={t('third.job')}
    //     thumbnail={t('third.thumbnail')}
    //     onClick={() => displayVideo(t('third.link'), t('third.author'))}
    //   />
    // </Carousel>
  );
};
